import Icon from '../components/Icon.vue'

Icon.register({"industry":{"width":1792,"height":1792,"paths":[{"d":"M448 0q26 0 45 19t19 45v891l536-429q17-14 40-14 26 0 45 19t19 45v379l536-429q17-14 40-14 26 0 45 19t19 45v1152q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/industry.js
// module id = 1040
// module chunks = 0